// extracted by mini-css-extract-plugin
module.exports = {"newsbox":"newsbox_newsbox__2lTaX","divider":"newsbox_divider__Zhvrf","text":"newsbox_text__3eetb"};